import { createSlice } from "@reduxjs/toolkit";

//STATE
const initialState = {
  rows: [],
  isLoading: false,
};

//STORE SLICE
export const itemTabsSlice = createSlice({
  name: "itemTabsSlice",
  initialState,
  //REDUCER
  reducers: {
    showLoading(state) {
      return {
        ...state,
        isLoading: true,
      };
    },
    hideLoading(state) {
      return {
        ...state,
        isLoading: false,
      };
    },
  },
});

//ACTIONS
export const {
    showLoading,
    hideLoading,
} = itemTabsSlice.actions;

export default itemTabsSlice.reducer;
